import React, { useState, useRef } from 'react';
import { useTranslation } from "react-i18next";
import Tooltip from '@mui/material/Tooltip';
import IconButton from '@mui/material/IconButton';
import Add_Img from 'images/panel/add-image.png'
import ClearIcon from '@mui/icons-material/Clear';
import { getDataSession } from 'views/Utils/Common';
import { fetchConToken } from 'helpers/fetch';
import { alertService } from '_services';
import Stack from '@mui/material/Stack';

const GaleriaImg = ({ data, isAdd, isEdit, saveData, sucursal, onClose }) => {
    const { t } = useTranslation("common");
    const [articulo, setArticulo] = useState(data);
    let [imagenes, setImagenes] = useState(data.imagenes);

    function handleChangeAddImg(data) {
        imagenes.push({ urlImagen: data });
        setImagenes(imagenes.filter((item) => item.urlImagen !== data.urlImagen));
    }

    function handleChangeRemove(data) {
        setImagenes(imagenes.filter((item) => item.urlImagen !== data.urlImagen));
    }

    function onClickGuardar () {
        articulo.imagenes = imagenes;
        setArticulo({...articulo, imagenes: imagenes });
        saveData(articulo);
    }
    
    return (<div style={{ display: 'flex', flexDirection: 'column', maxHeight: '80vh' }}>
        <div className='espacio15px' />
        <div className='espacio15px' />
        <div style={{ overflowY: 'auto', overflowX: 'hidden', flex: '1 1 auto', minHeight: '65vh' }}>
            <div className='row'>
                <div className='col-md-12' style={{ display: 'grid' }}>
                    <div className='card mb-3 '>
                        <div className='card-body'>
                            <label className='form-label'>{t('app.Articulos.form.imagenes')}*</label>
                            <div className='card mb-3 card-img'>
                                <div className='list_img'><ListImg data={imagenes} isAdd={isAdd} isEdit={isEdit} handleChangeAddImg={handleChangeAddImg} handleChangeRemove={handleChangeRemove} sucursal={sucursal} /></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div className='espacio5px' />
        <div className='row'>
            <div className='col-sm-8' />
            <div className='col-sm-2'>
                <button className='btn btn-outline-danger' onClick={onClose}>
                    <svg
                        xmlns='http://www.w3.org/2000/svg'
                        width='20'
                        height='20'
                        fill='currentColor'
                        className='bi bi-x-lg'
                        viewBox='0 0 16 16'
                    >
                        <path d='M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z' />
                    </svg>
                    &nbsp; &nbsp; {t('app.botones.cancelar')}
                </button>
            </div>
            <div className='col-sm-2'>
                <button className='btn btn-outline-success' onClick={onClickGuardar}>
                    <svg
                        xmlns='http://www.w3.org/2000/svg'
                        width='20'
                        height='20'
                        fill='currentColor'
                        className='bi bi-check-lg'
                        viewBox='0 0 16 16'
                    >
                        <path d='M12.736 3.97a.733.733 0 0 1 1.047 0c.286.289.29.756.01 1.05L7.88 12.01a.733.733 0 0 1-1.065.02L3.217 8.384a.757.757 0 0 1 0-1.06.733.733 0 0 1 1.047 0l3.052 3.093 5.4-6.425a.247.247 0 0 1 .02-.022Z' />
                    </svg>
                    &nbsp; {t('app.botones.guardar')}
                </button>
            </div>
        </div>
    </div>);
}

const ListImg = ({ data, isAdd, isEdit, handleChangeAddImg, handleChangeRemove, sucursal }) => {
    const handleCliclk = (item) => { if (handleChangeRemove) handleChangeRemove(item); }
    return (<>
        <div className='' style={{ minHeight: '45vh' }}>{data && data.length > 0 && (<img className='imgFull' src={data[0]?.urlImagen} alt={data[0]?.clave_Imagen} />)}</div>
        <div className='list_imge'>
            {isAdd && handleChangeAddImg && (<AddImg handleChangeAddImg={handleChangeAddImg} sucursal={sucursal} />)}
            <div className='list_imge'>
                <Stack direction="row" spacing={2}>
                    {data && data.map((item) => { return (<Img key={item.clave_Imagen} item={item} isEdit={isEdit && handleChangeRemove} handleCliclk={handleCliclk} />); })}
                </Stack>
            </div>
        </div>
    </>);
}

const Img = ({ item, isEdit, handleCliclk }) => {
    const handleCliclkInter = () => { handleCliclk(item); }
    return (
        <div className='img_art'>
            {isEdit && (<Tooltip title="Delete"><IconButton sx={{ color: 'black' }} className='iconButton' onClick={handleCliclkInter}><ClearIcon /></IconButton ></Tooltip>)}
            <img src={item?.urlImagen} alt={item?.clave_Imagen} />
        </div>
    );
}

const AddImg = ({ handleChangeAddImg, sucursal }) => {
    const imagen_nueva = useRef(null);
    const [sucursal_id] = useState(sucursal ? sucursal : getDataSession('sucursal'));
    const handleClick = () => imagen_nueva.current.click();
    const handleInputChangeFileConfig = ({ target }) => {
        if (target && target.files[0]) {
            const formData = new FormData();
            formData.append('empresa_id', getDataSession('empresa'));
            formData.append('sucursal_id', sucursal_id);
            formData.append('tipo', 'imagenes');
            formData.append('FileToUpload', target.files[0], target.files[0].name);
            fetchConToken('Archivos', formData, 'POST', true).then((response) => { handleChangeAddImg(response.url_Api); }).catch(alertService.error);
        }
    };

    return (
        <>
            <input type='file' className='input_file_hidden' name='imagen_nueva' onChange={handleInputChangeFileConfig} ref={imagen_nueva} />
            <Tooltip title="Seleccionar"><IconButton className='img_art_add' onClick={handleClick}><img src={Add_Img} className='img_art_add' alt='Add Img' /></IconButton></Tooltip>
        </>
    );
}

export { GaleriaImg, ListImg, AddImg };